export enum DenialStatus {
  Agreed = 0,
  Disagreed = 1,
  Pended = 2
}

// ts-prune-ignore-next
export const DenialStatusLabel: { [key in DenialStatus]: string } = {
  [DenialStatus.Agreed]: 'DENIAL_MANAGEMENT.STATUS.AGREED',
  [DenialStatus.Disagreed]: 'DENIAL_MANAGEMENT.STATUS.DIS_AGREED',
  [DenialStatus.Pended]: 'DENIAL_MANAGEMENT.STATUS.PENDED',
};

// ts-prune-ignore-next
export const DenialStatusValue: { [key in DenialStatus]: string } = {
  [DenialStatus.Agreed]: '11111111-1111-1111-1111-111111111111',
  [DenialStatus.Disagreed]: '22222222-2222-2222-2222-222222222222',
  [DenialStatus.Pended]: '33333333-3333-3333-3333-333333333333',
};

export const DenialDetailsLabelMapper = {
  [DenialStatus.Agreed]: {
      title: 'DENIAL_MANAGEMENT.STATUS.AGREED',
      color: '#3c3b44',
      backgroundColor: '#dfdee6',
      id: DenialStatusValue[DenialStatus.Agreed]
  },
  [DenialStatus.Disagreed]: {
      title: 'DENIAL_MANAGEMENT.STATUS.DIS_AGREED',
      color: '#d03131',
      backgroundColor: '#f2c4c4',
      id: DenialStatusValue[DenialStatus.Disagreed]
  },
  [DenialStatus.Pended]: {
      title: 'DENIAL_MANAGEMENT.STATUS.PENDED',
      color: '#36793d',
      backgroundColor: '#d7e9d8',
      id: DenialStatusValue[DenialStatus.Pended]
  }
};